const buildFacetQueryString = (facet) => {
    const { name } = facet;
    const facetQsa = `&facet=${name}`;
    return facetQsa;
}

export default buildFacetQueryString;